import { DateTime } from 'luxon';
import { ExtractStatus } from '../../api/ExtractApi';
import { DataType, SourceApiResponse, SourceType } from '../../api/SourceApi';
import translate, { Translations } from '../../language/translate';

export class Source {
  name: string = '';
  type: SourceType = SourceType.xero;
  connected: boolean = false;
  lastSync: DateTime = null;
  lastSyncStatus: ExtractStatus = ExtractStatus.COMPLETED;
  lastSyncError: string = '';
  dataTypes: DataType[] = [];
  externalId: string = '';

  static fromApi(apiData: SourceApiResponse): Source {
    const source = new Source();

    source.name = translate(Translations.Sources.Types[apiData.type as keyof typeof Translations.Sources.Types]);
    source.type = apiData.type as SourceType;
    source.connected = apiData.connected;
    source.lastSync = apiData.lastSyncTime
      ? DateTime.fromISO(apiData.lastSyncTime, { zone: 'utc' })
      : null;
    source.lastSyncStatus = apiData.lastSyncStatus as ExtractStatus;
    source.lastSyncError = apiData.lastSyncError;
    source.dataTypes = apiData.dataTypes as DataType[];
    source.externalId = apiData.externalId;

    return source;
  }
}
